import React, { useCallback, useEffect, useState } from 'react';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { debounce } from 'lodash';

const SearchByTransactionId = ({ languageString, onInputChange }) => {
    const [transactionId, setTransactionId] = useState('');
    const debouncedSearch = useCallback(
        debounce((searchValue) => {
            if (searchValue.trim()) {
                onInputChange(searchValue)
            }
        }, 1000),
        []
    );

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    useEffect(() => {
        if (transactionId.trim()) {
            debouncedSearch(transactionId);
        }
    }, [transactionId, debouncedSearch]);

    const handleInputChange = (event) => {
        setTransactionId(event.target.value);
    };

    const handleKeyDown = (event) => {
        if(event.keyCode === 13) {
            event.preventDefault();
        }
    }

    return (
        <fieldset>
            <div className="clear"></div>
            <s-box name="form-panel">
                <s-row>
                    <s-col span="6">
                        <div className="form-group">
                            <label>
                                <LanguageStringResolver string="vatCodeSearch_transactionId_label" />
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={LANGUAGE_CONTROLLER.format(
                                    languageString,
                                    'vatCodeSearch_transactionId_placeholder'
                                )}
                                onChange={handleInputChange}
                                onKeyDown={handleKeyDown}
                            />
                        </div>
                    </s-col>
                </s-row>
            </s-box>
        </fieldset>
    );
};

export default SearchByTransactionId;
